import { render, staticRenderFns } from "./UpdatePass.vue?vue&type=template&id=a87e0388&scoped=true"
import script from "./UpdatePass.vue?vue&type=script&lang=js"
export * from "./UpdatePass.vue?vue&type=script&lang=js"
import style0 from "./UpdatePass.vue?vue&type=style&index=0&id=a87e0388&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a87e0388",
  null
  
)

export default component.exports